import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

function BottomNavBar({ navItems }) {
    const location = useLocation();

    // Find the value for the BottomNavigation component. It must match one of the children's values.
    // We'll use the path for this. If no path matches, it will default to the first item.
    const currentValue = navItems.find(item => location.pathname.startsWith(item.path))?.path || (navItems.length > 0 ? navItems[0].path : false);

    if (!navItems || navItems.length === 0) {
        return null;
    }

    return (
        <Paper
            elevation={3}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                display: { xs: 'block', md: 'none' },
                // In de geïnstalleerde PWA (standalone) reserveren we ruimte voor de
                // home-indicator/swipe-streep, zodat de knoppen niet te dicht op de
                // schermrand zitten. In de gewone browser blijft de hoogte normaal.
                '@media (display-mode: standalone)': {
                    pb: 'env(safe-area-inset-bottom)',
                },
            }}
        >
            <BottomNavigation
                showLabels
                value={currentValue}
                // Transparant zodat de Paper de enige achtergrond levert; de kleur
                // loopt dan naadloos door in de safe-area-ruimte eronder (standalone).
                sx={{ backgroundColor: 'transparent' }}
            >
                {navItems.map((item) => (
                    <BottomNavigationAction
                        key={item.text}
                        label={item.text}
                        value={item.path}
                        icon={item.icon}
                        component={Link}
                        to={item.path}
                        sx={{
                            // minWidth 0 laat alle items de beschikbare breedte gelijk
                            // verdelen; anders dwingt de MUI-standaard (80px per item) op
                            // smalle schermen overflow af, waardoor labels afgekapt worden.
                            minWidth: 0,
                            px: 0.5,
                            '& .MuiBottomNavigationAction-label': {
                                fontSize: '0.7rem',
                                whiteSpace: 'nowrap',
                            },
                            '&.Mui-selected .MuiBottomNavigationAction-label': {
                                fontSize: '0.7rem',
                            },
                        }}
                    />
                ))}
            </BottomNavigation>
        </Paper>
    );
}

export default BottomNavBar;
